<template>
    <div>
      <div class="saldo-info mb-4">
        <div class="saldo-label">Saldo atual</div>
        <div class="saldo-valor">{{ saldoSelecionado.saldo }}</div>
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="input-container">
          <Select
            :options="tiposCreditoOptions"
            legend="Tipo de Crédito"
            placeholder="Selecione o tipo de crédito"
            :modelValue="tipoSelecionado"
            @update:modelValue="onSelecionarTipo"
            :disabled="loading"
          />
        </div>
        <div class="input-container">
          <Input
            type="number"
            :modelValue="quantidade"
            @update:modelValue="$event => quantidade = $event"
            mask="#####"
            legend="Quantidade de Créditos"
            placeholder="Informe a quantidade"
            v-model.number="quantidade"
            :disabled="loading || !tipoSelecionado"
          />
        </div>
        <div class="input-container" v-if="tipoSelecionado">
          <div class="valor-unitario">
            Valor unitário: <strong>{{ formatarMoeda(valorUnitario) }}</strong>
          </div>
        </div>
        <div class="resumo-compra mt-4" v-if="tipoSelecionado && quantidade > 0">
          <h3>Resumo da Compra</h3>
          <div class="resumo-item">
            <span>Tipo de crédito:</span>
            <span>{{ tipoSelecionadoText.toUpperCase() }}</span>
          </div>
          <div class="resumo-item">
            <span>Valor unitário:</span>
            <span>{{ formatarMoeda(valorUnitario) }}</span>
          </div>
          <div class="resumo-item">
            <span>Quantidade:</span>
            <span>{{ quantidade }}</span>
          </div>
          <div class="resumo-item total">
            <span>Total:</span>
            <span>{{ formatarMoeda(valorTotal) }}</span>
          </div>
        </div>
        <div class="buttons mt-4">
          <Button type="button" @handle:click="limpar" text="Limpar" :fill="false" color="danger" :disabled="loading" />
          <Button type="submit" @handle:click="handleSubmit" text="Confirmar Compra" color="primary" :disabled="loading || !tipoSelecionado || quantidade < 1">
            <LoadingSpinner v-if="loading" />
          </Button>
        </div>
      </form>
    </div>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import Input from 'core/Input'
import Select from 'core/Select'
import LoadingSpinner from 'core/LoadingSpinner'
import urlApi from '@/router/urlApiV2';

export default {
  name: 'ComprasCreditos',
  components: {
    PageContainer,
    Box,
    Button,
    Input,
    Select,
    LoadingSpinner,
  },

  props: {
    saldos: {
      type: Object|Array,
      default: function () {
        return {
          credito: { descricao: '' },
          saldo: 0
        }
      }
    }
  },
  data() {
    return {
      tiposCreditoOptions: [],
      tipoSelecionado: '',
      quantidade: 1,
      loading: false,
      mensagem: '',
      valoresTipos: {},
    }
  },
  computed: {
    valorUnitario() {
      console.log(this.valoresTipos)
      return this.tipoSelecionado ? (this.valoresTipos[this.tipoSelecionado] || 0) : 0
    },
    valorTotal() {
      return this.quantidade > 0 ? this.valorUnitario * this.quantidade : 0
    },
    tipoSelecionadoText() {
      const opt = this.tiposCreditoOptions.find(o => o.value === this.tipoSelecionado)
      return opt ? opt.text : ''
    },
    saldoSelecionado() {
      if (Array.isArray(this.saldos)) {
        return this.saldos.find(s => s.credito.id === this.tipoSelecionado) || { credito: { descricao: '' }, saldo: 0 }
      } else {
        return this.saldos
      }
    }
  },
  mounted() {
    this.carregarTiposCredito()
  },
  methods: {
    async carregarTiposCredito() {
      this.loading = true
      try {
        await this.$http.get(`${urlApi}/creditos/`)
          .then((response) => {
            this.tiposCreditoOptions = response.body.data.map(credito => ({
              value: credito.id,
              text: credito.descricao,
              valor: credito.preco
            }))

            this.valoresTipos = Object.fromEntries(response.body.data.map(d => [d.id, d.preco]))
            console.log(this.valoresTipos)
          })
          .catch((err) => {
            console.error(err)
            this.launchToast('fa-exclamation', err.data.dados || 'Erro ao carregar tipos de crédito.')
          })
      } catch (e) {
        this.mensagem = 'Erro ao carregar tipos de crédito.'
      } finally {
        this.loading = false
      }
    },
    onSelecionarTipo(val) {
      this.tipoSelecionado = val
      this.quantidade = 1
    },
    limpar() {
      this.tipoSelecionado = ''
      this.quantidade = 1
      this.mensagem = ''
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(valor)
    },
    async handleSubmit() {
      if (!this.tipoSelecionado || this.quantidade < 1) return
      this.loading = true
      try {
        let data = {
          quantidade: this.quantidade
        }
        await this.$http.post(`${urlApi}/creditos/purchase/${this.tipoSelecionado}`, data)
          .catch((err) => {
            console.error(err)
            this.launchToast('fa-exclamation', err.data.dados || 'Erro ao carregar saldo.')
          })
        this.limpar()
        this.$emit('compra-finalizada')
      } catch (e) {
        this.mensagem = 'Erro ao realizar compra.'
      } finally {
        this.loading = false
      }
    },
    launchToast(icon, msg) {
      this.$toasted.show(msg, {
        icon: icon,
        position: "top-right",
        duration: 5000,
        fullWidth: false
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.container-box {
  max-width: 520px;
  margin: 0 auto;
}
.saldo-info {
  text-align: center;
  .saldo-label {
    font-size: 1.1rem;
    color: #222;
    font-weight: 500;
  }
  .saldo-valor {
    font-size: 2.1rem;
    font-weight: 700;
    color: #1C2D5A;
    margin-bottom: 0.2rem;
  }
}
.input-container {
  margin-bottom: 1.5rem;
  legend {
    font-size: 1rem;
    font-weight: 600;
    color: #606264;
    margin-bottom: 0.5rem;
  }
  .valor-unitario {
    font-size: 1rem;
    color: #1C2D5A;
    margin-top: 0.5rem;
  }
}
.resumo-compra {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
  h3 {
    margin: 0 0 1rem 0;
    color: #1C2D5A;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .resumo-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    &.total {
      font-weight: 700;
      color: #1C2D5A;
      font-size: 1.1rem;
    }
  }
}
.buttons {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}
</style>
